import { render, staticRenderFns } from "./DataMonthReceivedStatistics.vue?vue&type=template&id=3e6ca1f4&scoped=true"
import script from "./DataMonthReceivedStatistics.vue?vue&type=script&lang=js"
export * from "./DataMonthReceivedStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataMonthReceivedStatistics.vue?vue&type=style&index=0&id=3e6ca1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ca1f4",
  null
  
)

export default component.exports